module.exports = __webpack_public_path__ + "img/kh.ff9687b3.svg";